__turbopack_context__.v({
  "sectionStepperTabs": "UCa3eq_sectionStepperTabs",
  "stepButton": "UCa3eq_stepButton",
  "stepDetails": "UCa3eq_stepDetails",
  "stepIndicator": "UCa3eq_stepIndicator",
  "stepLabel": "UCa3eq_stepLabel",
  "stepMeta": "UCa3eq_stepMeta",
  "tabsContainer": "UCa3eq_tabsContainer",
});
